import { render, staticRenderFns } from "./VendorEvaluation.vue?vue&type=template&id=359a073d&scoped=true"
import script from "./VendorEvaluation.vue?vue&type=script&lang=js"
export * from "./VendorEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359a073d",
  null
  
)

export default component.exports